export enum LOCATION_STATUS_TYPES {
  Success = 'success',
  Pending = 'pending',
  Denied = 'denied',
  AlreadyDenied = 'already_denied',
}

enum LOCATION_CODE {
  PermissionDenied = 1,
}

export function getGeoLocation(): Promise<any> {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    if (navigator.geolocation) {
      // eslint-disable-next-line no-undef
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          if (error.code === LOCATION_CODE.PermissionDenied) {
            reject(LOCATION_STATUS_TYPES.Denied);
          }
        },
        {
          enableHighAccuracy: false,
          timeout: 5000,
          maximumAge: 10000,
        }
      );
    } else {
      reject(LOCATION_STATUS_TYPES.AlreadyDenied);
    }
  });
}
